module.exports = __webpack_public_path__ + "img/bana.1936b50c.jpeg";